// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datetime-container-ulASe {
  width: 280px;
  position: relative;
}

.datetime-hiddenInput-MsSw9 {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  pointer-events: none;
  visibility: hidden;
}

.datetime-label-g0skT {
  display: block;
  font-size: 14px;
  color: var(--color-neutral-800);
  margin-bottom: 8px;
}

.datetime-input-ZWc0I {
  width: 100%;
  height: 44px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  color: var(--color-neutral-800);
  border: 1px solid var(--color-neutral-300);
  border-radius: var(--radius-lg);
  padding: 0px 8px;
  cursor: pointer;
  user-select: none;
  z-index: 1;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.datetime-input-ZWc0I:focus-within { 
  border-color: var(--color-neutral-800);
  box-shadow: 0 0 0 0.5px var(--color-neutral-800);
}

.datetime-active-nMZi1 {
  color: var(--color-neutral-900);
}

.datetime-icon-OWpbP {
  --size: 22px;
  margin-right: 12px;
}

.datetime-value-zpp3l {
  flex-grow: 1;
}

.datetime-expandMoreIcon-NZG7V {
  --size: 22px;
}

.datetime-clearIcon-cHjWy {
  --size: 20px;
}

.datetime-activeIcon-_Z1i1 {
  color: var(--color-neutral-900);
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/datetime/datetime.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,0CAA0C;EAC1C,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,wDAAwD;AAC1D;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC","sourcesContent":[".container {\n  width: 280px;\n  position: relative;\n}\n\n.hiddenInput {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  pointer-events: none;\n  visibility: hidden;\n}\n\n.label {\n  display: block;\n  font-size: 14px;\n  color: var(--color-neutral-800);\n  margin-bottom: 8px;\n}\n\n.input {\n  width: 100%;\n  height: 44px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 15px;\n  color: var(--color-neutral-800);\n  border: 1px solid var(--color-neutral-300);\n  border-radius: var(--radius-lg);\n  padding: 0px 8px;\n  cursor: pointer;\n  user-select: none;\n  z-index: 1;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.input:focus-within { \n  border-color: var(--color-neutral-800);\n  box-shadow: 0 0 0 0.5px var(--color-neutral-800);\n}\n\n.active {\n  color: var(--color-neutral-900);\n}\n\n.icon {\n  --size: 22px;\n  margin-right: 12px;\n}\n\n.value {\n  flex-grow: 1;\n}\n\n.expandMoreIcon {\n  --size: 22px;\n}\n\n.clearIcon {\n  --size: 20px;\n}\n\n.activeIcon {\n  color: var(--color-neutral-900);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `datetime-container-ulASe`,
	"hiddenInput": `datetime-hiddenInput-MsSw9`,
	"label": `datetime-label-g0skT`,
	"input": `datetime-input-ZWc0I`,
	"active": `datetime-active-nMZi1`,
	"icon": `datetime-icon-OWpbP`,
	"value": `datetime-value-zpp3l`,
	"expandMoreIcon": `datetime-expandMoreIcon-NZG7V`,
	"clearIcon": `datetime-clearIcon-cHjWy`,
	"activeIcon": `datetime-activeIcon-_Z1i1`
};
export default ___CSS_LOADER_EXPORT___;
